import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IContact } from 'components/DealForm/types';
import useAuthContext from 'contexts/AuthContext';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { trackDatadogRumError } from 'utils/initDatadogRum';

const getOrganizationContacts = async (
    orgId: string,
): Promise<IContact[]> => {
    const response = await axiosInstance.get<IContact[]>(
        API_ENDPOINTS.ORGANIZATION_CONTACTS(orgId),
    );
    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useGetOrganizationContacts] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

export const useGetOrganizationContacts = (
    options?: Omit<UseQueryOptions<IContact[]>, 'queryKey' | 'queryFn'>,
) => {
    const { selectedOrganizationId } = useAuthContext();
    return useQuery<IContact[], Error>({
        queryKey: [QUERY_KEYS.ORGANIZATION.CONTACTS, selectedOrganizationId],
        queryFn: () => getOrganizationContacts(selectedOrganizationId!),
        enabled: Boolean(selectedOrganizationId),
        ...(options ?? {}),
    });
};
